export const links = ["home", "products", "about"];
export const crousel_images = ["./images/delivery.png", "./images/shirts1.jpg"];
export const products = [
  {
    title: "Sweat-shirt",
    price: 600,
    image: "./images/sweatshirt1.jpg",
    color: "black",
    size: "S",
    category: "sweatshirt",
    piece: 0,
    id: 1,
  },
  {
    title: "Sweat-shirt",
    price: 600,
    image: "./images/sweatshirt2.jpg",
    color: "grey",
    size: "M",
    category: "sweatshirt",
    piece: 0,
    id: 2,
  },
  {
    title: "Sweat-shirt",
    price: 600,
    image: "./images/t-shirt2.jpg",
    color: "green",
    size: "M",
    category: "tees",
    piece: 0,
    id: 3,
  },
  {
    title: "Warm Hoody",
    price: 600,
    image: "./images/hoodies1.jpeg",
    color: "black",
    size: "M",
    category: "hoodies",
    piece: 0,
    id: 4,
  },
  {
    title: "Warm Hoody",
    price: 600,
    image: "./images/hoodies2.jpeg",
    color: "white",
    size: "M",
    category: "hoodies",
    piece: 0,
    id: 5,
  },
  {
    title: "Warm Hoody",
    price: 600,
    image: "./images/hoodies3.jpeg",
    color: "grey",
    size: "M",
    category: "hoodies",
    piece: 0,
    id: 6,
  },
  {
    title: "Warm Hoody",
    price: 600,
    image: "./images/hoodies4.jpeg",
    color: "blue",
    size: "M",
    category: "hoodies",
    piece: 0,
    id: 7,
  },
  {
    title: "Branded Jeans",
    price: 1000,
    image: "./images/jeans1.jpg",
    color: "blue",
    size: "S",
    category: "jeans",
    piece: 0,
    id: 8,
  },

  {
    title: "Branded Jeans",
    price: 1000,
    image: "./images/jeans2.jpg",
    color: "grey",
    size: "S",
    category: "jeans",
    piece: 0,
    id: 9,
  },
  {
    title: "Branded Jeans",
    price: 1000,
    image: "./images/jeans3.jpg",
    color: "blue",
    size: "S",
    category: "jeans",
    piece: 0,
    id: 10,
  },
  {
    title: "Formal Pant",
    price: 700,
    image: "./images/formalpant1.jpg",
    color: "black",
    size: "M",
    category: "formal pant",
    piece: 0,
    id: 11,
  },
  {
    title: "Formal Pant",
    price: 700,
    image: "./images/formalpant2.jpg",
    color: "blue",
    size: "M",
    category: "formal pant",
    piece: 0,
    id: 12,
  },
  {
    title: "Formal Pant",
    price: 700,
    image: "./images/formalpant3.jpg",
    color: "grey",
    size: "M",
    category: "formal pant",
    piece: 0,
    id: 13,
  },
  {
    title: "Adidas Trouser",
    price: 1200,
    image: "./images/trouser1.jpeg",
    color: "grey",
    size: "S",
    category: "trousers",
    piece: 0,
    id: 14,
  },
  {
    title: "Jordan Trouser",
    price: 1100,
    image: "./images/trouser2.jpeg",
    color: "black",
    size: "S",
    category: "trousers",
    piece: 0,
    id: 15,
  },
  {
    title: "3-Panel Trouser",
    price: 700,
    image: "./images/trouser3.jpeg",
    color: "blue",
    size: "M",
    category: "trousers",
    piece: 0,
    id: 16,
  },
  {
    title: "Tees",
    price: 499,
    image: "./images/tees1.jpg",
    color: "white",
    size: "S",
    category: "tees",
    piece: 0,
    id: 17,
  },
  {
    title: "Tees",
    price: 499,
    image: "./images/tees2.jpg",
    color: "black",
    size: "S",
    category: "tees",
    piece: 0,
    id: 18,
  },
  {
    title: "Tees",
    price: 499,
    image: "./images/tees3.jpg",
    color: "blue",
    size: "S",
    category: "tees",
    piece: 0,
    id: 19,
  },
  {
    title: "Full-Sleeve T-shirt",
    price: 799,
    image: "./images/fullsleeve1.jpeg",
    color: "red",
    size: "M",
    category: "T-shirts",
    piece: 0,
    id: 20,
  },
  {
    title: "Full-Sleeve T-shirt",
    price: 799,
    image: "./images/fullsleeve2.jpeg",
    color: "black",
    size: "M",
    category: "T-shirts",
    piece: 0,
    id: 21,
  },
  {
    title: "Full-Sleeve T-shirt",
    price: 799,
    image: "./images/fullsleeve3.jpeg",
    color: "blue",
    size: "S",
    category: "T-shirts",
    piece: 0,
    id: 22,
  },
  {
    title: "Plain Shirt",
    price: 650,
    image: "./images/formalshirt1.jpg",
    color: "grey",
    size: "M",
    category: "formal shirts",
    piece: 0,
    id: 23,
  },
  {
    title: "Plain Shirt",
    price: 650,
    image: "./images/formalshirt2.jpg",
    color: "blue",
    size: "M",
    category: "formal shirts",
    piece: 0,
    id: 24,
  },
  {
    title: "Plain Shirt",
    price: 650,
    image: "./images/formalshirt3.jpg",
    color: "black",
    size: "M",
    category: "formal shirts",
    piece: 0,
    id: 25,
  },
];
export const featured_products = [
  {
    title: "Premium Quality Suit",
    price: "1999Rs",
    image: "./images/featured_product1.jpg",
  },
  {
    title: " Branded Jeans",
    price: "999Rs",
    image: "./images/featured_product2.jpg",
  },
  {
    title: "Premium Quality Shirt",
    price: "1299Rs",
    image: "./images/featured_product3.jpg",
  },
];
